import { GlobalTokens } from "../../../@tokens/GlobalTokens";
import { BrandTokens } from "../../../@tokens/BrandTokens";
import { hexToRGB } from "../../../helpers/Colors/colors";


export const style: any = {
    theme: {

        motion: {
            transitionDuration: GlobalTokens.MotionSwitchSlow?.TransitionDuration,
            transitionTimingFunction: GlobalTokens.MotionSwitchSlow?.TransitionTimingFunction
        },

        lightbox: {
            backgroundColor: hexToRGB(
                BrandTokens.NeutralColorLowPure,
                GlobalTokens.OpacityLevelIntense
            ),
        },
        modal: {
            sizes: {
                mobile: {
                    backgroundColor: BrandTokens.NeutralColorHighPure,
                    padding: GlobalTokens.SpacingInsetSizeSm,
                },
                tablet: {
                    backgroundColor: BrandTokens.NeutralColorHighPure,
                    boxShadow: GlobalTokens.ShadowLevel3,
                    borderRadius: GlobalTokens.BorderRadiusMd,
                },
            },
        },
        footer: {
            sizes: {
                tablet: {
                    backgroundColor: BrandTokens.NeutralColorHighLight,
                    padding: GlobalTokens.SpacingSizeXxs,
                },
            },
        },
    }
}